import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { GoonAPIClient } from '../client/ApiClient';
import { API_ENDPOINT } from '../constants';
import { prepareImageAsWebP } from '../utils/webp';

const api = new GoonAPIClient(API_ENDPOINT);

@customElement('create-channel-modal')
export class CreateChannelModal extends LitElement {
  @state() name = '';
  @state() imageFile: File | null = null;
  @state() imagePreview: string | null = null;
  @state() loading = false;
  @state() error = '';

  @property() open = false;

  createRenderRoot() { return this; }

  handleImageUpload(e: Event) {
    const target = e.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.imageFile = target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.imageFile);
    }
  }

  close() {
    this.dispatchEvent(new CustomEvent('close'));
  }

  async handleSubmit() {
    this.loading = true;
    this.error = '';
    try {
      let imageUrl = '';
      if (this.imageFile) {
        const webpBlob = await prepareImageAsWebP(this.imageFile, 256, 256);
        const webpFile = new File([webpBlob], 'channel-image.webp', { type: 'image/webp' });
        const mediaUrl = await api.uploadMediaAndWait(webpFile, 'channel-image', 'image/webp');
        imageUrl = mediaUrl;
      }
      const channel = await api.createChannel({ name: this.name, imageUrl: imageUrl });
      window.location.href = `/channel/${channel.slug}`;
    } catch (err) {
      this.error = 'Failed to create channel';
    } finally {
      this.loading = false;
      this.close();
    }
  }

  render() {
    return html`
      <div class="${this.open ? 'fixed inset-0 z-40 backdrop-blur-sm bg-black/30' : 'hidden'}"></div>
      <dialog class="modal ${this.open ? 'modal-open' : ''}">
        <div class="modal-box">
          <form method="dialog">
            <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" @click=${() => this.close()}>✕</button>
          </form>
          <h3 class="text-lg font-bold mb-4">Create Channel</h3>
          <div class="form-control mb-3">
            <label class="label">
              <span class="label-text">Channel Name</span>
            </label>
            <input class="input input-bordered w-full" type="text" .value=${this.name} @input=${e => this.name = (e.target as HTMLInputElement).value} />
          </div>
          <div class="form-control mb-4">
            <label class="label">
              <span class="label-text">Channel Image</span>
            </label>
            <input class="file-input file-input-accent w-full" type="file" @change=${this.handleImageUpload} />
            ${this.imagePreview ? html`<img src="${this.imagePreview}" class="mt-2 rounded w-full h-auto" />` : ''}
          </div>
          ${this.error ? html`<div class="text-error mb-2">${this.error}</div>` : ''}
          <button class="btn btn-primary w-full" ?disabled=${this.loading} @click=${this.handleSubmit}>Create</button>
        </div>
        <form method="dialog" class="modal-backdrop">
          <button @click=${() => this.close()}>close</button>
        </form>
      </dialog>
    `;
  }
}

